import styled from 'styled-components/macro'
import { media, per } from '../../utils/styles'

const MainBannerContent = styled.div`
  text-align: center;

  ${media('tablet')`
    max-width: ${per(8, 12)};
  `}
`

export default MainBannerContent
